import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import Swal from 'sweetalert2';
import Moment from 'moment';
import 'moment/locale/es';
import { useParams } from 'react-router-dom';
import { getClientes } from '../../../services/clientes/clientesService';
import { lenguage, optionsTable, tableIcons } from "../../structure/config-datatable";
import { ClientesEditModal } from './edit-modal/ClientesEditModal';

export const DatatableClientes = () => {
    const { id_contador } = useParams();
    const [state, setState] = useState([]);
    const [modalEditar, setModalEditar] = useState(false);
    const [edit, setEdit] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    // Cargar clientes
    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const data = await getClientes(id_contador || null);
                setState(data);
            } catch (error) {
                console.log('Error fetching clientes:', error);
                Swal.fire('Error', 'Error al cargar clientes', 'error');
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, [id_contador]);

    // Acciones de la tabla
    const acciones = [
        {
            icon: () => <tableIcons.Edit style={{ color: "#FFC007" }} />,
            tooltip: 'Editar',
            onClick: (e, rowData) => {
                setEdit({
                    id: rowData.id,
                    razon_social: rowData.razon_social,
                    nit: rowData.nit,
                    div: rowData.div,
                    telefono: rowData.telefono,
                    nombre_representante: rowData.nombre_representante,
                    gran_contribuyente: rowData.gran_contribuyente,
                    comentarios: rowData.comentarios,
                    estado: rowData.estado,
                    contador_nombre: rowData.contador_nombre,
                    regimen: rowData.regimen,
                    tipo_membresia: rowData.tipo_membresia
                });
                setModalEditar(true);
            }
        }
    ];

    // Columnas de la tabla
    const columnas = [
        {
            title: "Razón Social",
            field: "razon_social",
            width: "20%"
        },
        {
            title: "NIT",
            field: "nit",
            render: rowData => `${rowData.nit} - ${rowData.div}`
        },
        {
            title: "Teléfono",
            field: "telefono",
        },
        {
            title: "Nombre Representante",
            field: "nombre_representante",
        },
        {
            title: "Contador",
            field: "contador_nombre",
        },
        {
            title: "Ciudades",
            field: "ciudades",
        },
        {
            title: "Régimen",
            field: "regimen",
        },
        {
            title: "Gran Contribuyente",
            field: "gran_contribuyente",
            render: rowData => (
                <span style={{ fontWeight: 'bold' }}>
                    {rowData.gran_contribuyente === 1 || rowData.gran_contribuyente === true ? "Sí" : "No"}
                </span>
            )
        },
        {
            title: "Membresía",
            field: "tipo_membresia",
        },
        {
            title: "Vencimiento",
            field: "fecha_vencimiento",
            render: rowData =>
                rowData.fecha_vencimiento !== undefined ?
                    Moment(rowData.fecha_vencimiento).format("D MMM YYYY")
                    : ""
        },
        {
            title: "Estado",
            field: "estado",
            width: "10%",
            render: rowData => (
                <span className="badge" style={{
                    backgroundColor: rowData.estado === 1 ? "#28a745" : "#dc3545",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "4px",
                    fontWeight: "bold"
                }}>
                    {rowData.estado === 1 ? "Activo" : "Inactivo"}
                </span>
            )
        }
    ];

    // Recargar tabla después de editar
    const handleReload = async () => {
        const data = await getClientes(id_contador || null);
        setState(data);
    };

    return (
        <>
            {!isLoading ? (
                <div className="card-body">
                    <div style={{
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        marginBottom: '20px',
                        borderRadius: '4px',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)'
                    }}>
                        <MaterialTable
                            icons={tableIcons}
                            columns={columnas}
                            data={state}
                            title={""}
                            options={optionsTable}
                            localization={lenguage}
                            actions={acciones}
                        />
                    </div>
                    <ClientesEditModal
                        setModalEditar={setModalEditar}
                        modalEditar={modalEditar}
                        editar={edit}
                        onReload={handleReload}
                    />
                </div>
            ) : (
                <div
                    className="card-body"
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "400px",
                    }}
                >
                    <div className="loader-carga"></div>
                </div>
            )}
        </>
    );
};
